function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h80v80H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 15.362)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.285 33.24c10.984 3.827 13.462 4.688 4.982 8.064-.036-.064.017.45 0 4.64-.011 2.657-8.747 2.657-8.754 0v-4.64h-8.59l.038 4.64c-.137 2.654-8.87 2.66-8.84 0v-4.64c-7.46-.573-12.017-2.939-14.392-8.887-.139.012-1.628.008-4.667 0-2.492.32-3.759-1.563-3.8-5.65-.042-4.088.962-6.34 3.011-6.756h4.102c2.078-6.493 5.219-10.553 12.404-12.402.021-1.485-.033-6.761 0-7.547 5.834-.138 8.091 2.81 8.091 7.547.122.071.362.091.347.208-.53 4.114-7.233 1.733-6.887 9.447.125 2.797 2.344 5.747 6.432 8.623 4.088 2.877 5.54 3.528 16.523 7.354zM15.104 21.015c.993 0 1.798-.81 1.798-1.811 0-1-.805-1.812-1.798-1.812s-1.798.811-1.798 1.812c0 1 .805 1.811 1.798 1.811z",
  fill: "#43A047"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.783 24.308a36.468 36.468 0 01-.148 2.897c-.555 5.821-2.888 10.723-11.368 14.1-.036-.065.017.45 0 4.64-.011 2.656-8.747 2.656-8.754 0v-4.64h-8.59l.038 4.64c-.137 2.653-8.87 2.66-8.84 0v-4.64c-7.46-.574-12.017-2.94-14.392-8.888-.139.012-1.628.008-4.667 0-2.492.32-3.759-1.563-3.8-5.65-.042-4.088.962-6.34 3.011-6.756h4.102c2.078-6.493 5.219-10.553 12.404-12.402.021-1.485-.033-6.761 0-7.547 5.834-.138 8.091 2.81 8.091 7.547 12.932.022 5.46-.057 15.373 0 5.215.03 9.576 1.81 12.654 4.984",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 15.104,
  cy: 19.203,
  rx: 1.798,
  ry: 1.812
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#371447",
  x: 29.988,
  y: 10.645,
  width: 16.981,
  height: 2.261,
  rx: 1.13
})), /*#__PURE__*/React.createElement("path", {
  d: "M42.54 40.194c-.801.677-1.369 1.53-1.642 2.507-.924 4.023-2.895 5.64-7.093 5.378 6.079 6.615 14.148 6.17 18.164-.122.555-.87-.746-3.928-3.27-3.672-9.21.933-5.48-4.664-6.158-4.091z",
  fill: "#43A047"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.177 38.785l3.024 3.332L77.37 25.604a3.678 3.678 0 00.792-5.341l-.068-.082a3.895 3.895 0 00-5.49-.447L50.178 38.785z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.119 51.839c5.262.085 8.59-1.52 9.983-4.815",
  stroke: "#371447",
  strokeWidth: 1.083
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.692 31.057c2.217 2.293 2.273 4.174 2.309 4.638",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.247 47.836c.882 1.366 6.044 7.162 12.837 4.16 4.53-2 6.53-5.237 6.004-9.71L50.25 38.92c-4.309-.723-6.996-.024-8.06 2.095-3.951 7.872-3.795 6.59-7.942 6.822z",
  stroke: "#371447",
  strokeWidth: 1.083
}));

function SvgMakeYourOwnLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMakeYourOwnLg;